const paths = {
  listServiceClass: '/service-class/list',
  editServiceClass: '/service-class/edit'
};

export default paths;
